import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-new-folder-placeholder',
  templateUrl: './add-new-folder-placeholder.component.html',
  styleUrls: ['./add-new-folder-placeholder.component.less']
})
export class AddNewFolderPlaceholderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
